import { KeyValue } from '@/main/models/common';
import {
  SummaryTypes,
  SummaryActionTypes
} from './summaryTypes';
import { SummaryRequest } from '@/main/models/request/summaryRequest';

export function getSummary(
  request: SummaryRequest
): SummaryActionTypes {
  return {
    type: SummaryTypes.GET_SUMMARY,
    payload: {
      request: request
    }
  };
}

export function saveSummary(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): SummaryActionTypes {
  return {
    type: SummaryTypes.SAVE_SUMMARY,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerSummary(): SummaryActionTypes {
  return {
    type: SummaryTypes.RESET_REDUCER_SUMMARY
  };
}

